import { render, staticRenderFns } from "./baiguullaga_tanilts.vue?vue&type=template&id=f3abf4da&scoped=true&"
import script from "./baiguullaga_tanilts.vue?vue&type=script&lang=js&"
export * from "./baiguullaga_tanilts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3abf4da",
  null
  
)

export default component.exports